import { render, staticRenderFns } from "./AssignmentsFormCreate.vue?vue&type=template&id=66d7a120&"
import script from "./AssignmentsFormCreate.vue?vue&type=script&lang=js&"
export * from "./AssignmentsFormCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports